import React, { useEffect } from "react";

import { PromptMessage } from "../common";
import emojiGreat from "../assets/emojiGreat.svg";
import emojiSmiling from "../assets/emojiSmiling.svg";
import emojiNeutral from "../assets/emojiNeutral.svg";
import emojiDisappointed from "../assets/emojiDisappointed.svg";
import emojiCrying from "../assets/emojiCrying.svg";
import { translationPrefix } from "../data/index.js";
// import Translation from '../../../services/translation.service'; --- IGNORE ---
import Translation from "../../../../services/translation.service.js";
import Storage from "../../../../services/storage.service";

const getStorageValue = (key) => {
  let business = JSON.parse(Storage.get("business", true))
  let poValue = business["fraud_validation"] ? business["fraud_validation"] : "";
  if (poValue) {
      return poValue[key] ? poValue[key] : "";
  } else {
      return "";
  }

}
const RatingsForm = ({
  selectedRating,
  setSelectedRating,
  feedback,
  setFeedback,
  onSubmit,
}) => {
  const emojisArrayMap = [
    {
      image: emojiGreat,
      value: 5,
      text: Translation.keys[translationPrefix + "survey_rating_great"],
    },
    {
      image: emojiSmiling,
      value: 4,
      text: Translation.keys[translationPrefix + "survey_rating_good"],
    },
    {
      image: emojiNeutral,
      value: 3,
      text: Translation.keys[translationPrefix + "survey_rating_ok"],
    },
    {
      image: emojiDisappointed,
      value: 2,
      text: Translation.keys[translationPrefix + "survey_rating_bad"],
    },
    {
      image: emojiCrying,
      value: 1,
      text: Translation.keys[translationPrefix + "survey_rating_terrible"],
    },
  ];

  const isEmojiSelected = (value) => selectedRating?.value === value;
  const isUserSatisfactionLessThanFour =
    selectedRating && selectedRating.value < 4;

  // Check if button should be enabled (same logic as button className)
  const isButtonEnabled = selectedRating;

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter' && isButtonEnabled) {
        // Don't submit if Enter is pressed in textarea
        if (event.target.tagName !== 'TEXTAREA') {
          onSubmit();
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [isButtonEnabled, onSubmit]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="ratings-form">
      <div className="heading">
        {Translation.keys[translationPrefix + "survey_rating_title"]}
      </div>
      <div className="emojis-container">
        {emojisArrayMap.map((emoji) => (
          <div
            key={emoji.value}
            className={`emoji-rating ${
              isEmojiSelected(emoji.value) ? "active-emoji-rating" : ""
            }`}
            onClick={() => setSelectedRating(emoji)}
          >
            <img src={emoji.image} alt={`Emoji rating ${emoji.value}`} />
            <div>{emoji.text}</div>
          </div>
        ))}
      </div>
      {isUserSatisfactionLessThanFour && (
        <>
          <div className="tell-us-more">
            {Translation.keys[translationPrefix + "survey_rating_tell_us_more"]}
          </div>
          <textarea
            className="feedback-field"
            value={feedback}    
            onChange={(e) => setFeedback(e.target.value)}
            maxLength={getStorageValue("fraud_note_max_limit")}
            placeholder={Translation.keys["scr_survey_feed_back_hint"]}
          />
        </>
      )}
      <PromptMessage />
      <button
        onClick={onSubmit}
        className={`common-button ${!selectedRating ? "button-disabled" : ""}`}
      >
        {Translation.keys[translationPrefix + "survey_next"]}
      </button>
    </div>
  );
};

export default RatingsForm;
